import { DSISearchInputs, DSISearchItem, DSIAddInputs } from '../Models/DSIModel';
import { postObject } from '../ChoiceApi';

export async function add(payload: DSIAddInputs): Promise<boolean|undefined> {
    return await postObject("api/DSI/Add", payload);
} 

export async function search(payload: DSISearchInputs): Promise<DSISearchItem[]> {
    return (await postObject("api/DSI/Search", payload)) as DSISearchItem[];
}